import { importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  provideAnimations,
  provideNoopAnimations,
} from '@angular/platform-browser/animations';
import {
  AimOutline,
  ApartmentOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  BankOutline,
  BarChartOutline,
  BellOutline,
  BranchesOutline,
  CalendarOutline,
  CameraOutline,
  CarOutline,
  CarTwoTone,
  ClockCircleOutline,
  CloseOutline,
  ClusterOutline,
  CreditCardOutline,
  CrownOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DeleteOutline,
  DollarCircleOutline,
  DollarOutline,
  DownloadOutline,
  DragOutline,
  EnvironmentFill,
  EnvironmentOutline,
  ExclamationCircleOutline,
  ExclamationCircleTwoTone,
  ExperimentTwoTone,
  EyeInvisibleOutline,
  EyeOutline,
  FileExcelOutline,
  FileImageOutline,
  FilePdfOutline,
  FileSearchOutline,
  FileTextOutline,
  FlagOutline,
  GiftFill,
  GiftOutline,
  HeartFill,
  HistoryOutline,
  HolderOutline,
  HomeOutline,
  IdcardOutline,
  InboxOutline,
  LinkOutline,
  LoadingOutline,
  LockFill,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MessageOutline,
  MessageTwoTone,
  MoreOutline,
  NumberOutline,
  PhoneOutline,
  PictureOutline,
  PictureTwoTone,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  PrinterOutline,
  QuestionCircleOutline,
  ReloadOutline,
  RightOutline,
  RiseOutline,
  RocketOutline,
  SafetyCertificateOutline,
  SafetyCertificateTwoTone,
  SaveOutline,
  SearchOutline,
  SendOutline,
  SettingOutline,
  ShoppingOutline,
  SmileOutline,
  StarOutline,
  StarTwoTone,
  SyncOutline,
  TagOutline,
  TeamOutline,
  ThunderboltFill,
  ThunderboltOutline,
  ToolOutline,
  TrophyOutline,
  TrophyTwoTone,
  UnorderedListOutline,
  UserAddOutline,
  UserDeleteOutline,
  UserOutline,
  WarningFill,
  WarningOutline,
  WifiOutline,
} from '@ant-design/icons-angular/icons';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { NzIconModule, provideNzIcons } from 'ng-zorro-antd/icon';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// Production builds don't write debug output to the browser console (it can include user data).
// Warnings and errors are kept.
if (!isDevMode()) {
  const noop = () => undefined;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideNzI18n(en_US),
    provideNzIcons([
      DashboardOutline,
      ApartmentOutline,
      ClusterOutline,
      UserAddOutline,
      IdcardOutline,
      CarOutline,
      SyncOutline,
      MailOutline,
      CalendarOutline,
      DollarOutline,
      LogoutOutline,
      SearchOutline,
      WarningOutline,
      CloseOutline,
      ArrowRightOutline,
      RightOutline,
      PlusOutline,
      PictureTwoTone,
      InboxOutline,
      DeleteOutline,
      MessageOutline,
      HistoryOutline,
      MoreOutline,
      DownloadOutline,
      ReloadOutline,
      LinkOutline,
      FilePdfOutline,
      SaveOutline,
      FileImageOutline,
      CameraOutline,
      LockFill,
      ThunderboltFill,
      HolderOutline,
      DragOutline,
      FileSearchOutline,
      TeamOutline,
      CreditCardOutline,
      FileTextOutline,
      StarOutline,
      BranchesOutline,
      EnvironmentOutline,
      StarTwoTone,
      TrophyTwoTone,
      SafetyCertificateTwoTone,
      MessageTwoTone,
      CarTwoTone,
      ExperimentTwoTone,
      SendOutline,
      UserOutline,
      SafetyCertificateOutline,
      LockOutline,
      NumberOutline,
      FlagOutline,
      PhoneOutline,
      LoginOutline,
      DollarCircleOutline,
      TrophyOutline,
      UserDeleteOutline,
      ToolOutline,
      WarningFill,
      FileExcelOutline,
      PrinterOutline,
      RiseOutline,
      ArrowLeftOutline,
      BankOutline,
      BellOutline,
      SettingOutline,
      UnorderedListOutline,
      PlusCircleOutline,
      CrownOutline,
      SmileOutline,
      GiftOutline,
      HeartFill,
      PictureOutline,
      AimOutline,
      ThunderboltOutline,
      ShoppingOutline,
      WifiOutline,
      GiftFill,
      BarChartOutline,
      PlayCircleOutline,
      ExclamationCircleOutline,
      ExclamationCircleTwoTone,
      EnvironmentFill,
      HomeOutline,
      EyeOutline,
      EyeInvisibleOutline,
      ClockCircleOutline,
      CustomerServiceOutline,
      LoadingOutline,
      QuestionCircleOutline,
      RocketOutline,
      TagOutline,
    ]),
    importProvidersFrom(
      NzIconModule.forChild([MenuFoldOutline, MenuUnfoldOutline]),
    ),
    provideNoopAnimations(),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
